<template>
  <div class="wrapper">
    <nav-bar></nav-bar>
    <div class="main-content">
      <fade-transition :duration="200" origin="center top" mode="out-in">
        <router-view></router-view>
      </fade-transition>
    </div>
  </div>
</template>
<script>
  import { FadeTransition } from 'vue2-transitions';
  import NavBar from '@/components/NavBar.vue';


  export default {
    title: 'ORIPAY® - Deposit',
    data(){
      return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
      }
    },
    components: {
      FadeTransition,
      NavBar
    },
    methods: {
      
    },
    mounted() {

    }
  };
</script>
